import { COMPATIBLE_APP_VERSION } from 'App/version';

export function getAppVersion(): string {
  return COMPATIBLE_APP_VERSION;
}
